import React, {  } from 'react';
import { useDispatch } from "react-redux";
import '../Css/Map.css';
import { Modal } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import Map from '../pages/Map.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow, faMapMarkedAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalMap = (props) => {
    const {popData, setPopData, location} = props
    const { show } = popData;

    const close = () => {
        setPopData({ show: false });
    }
    return (
        <Modal show={show} size='lg' style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span><FontAwesomeIcon icon={faMapMarkedAlt} size='lg'/>&nbsp; انتخاب از نقشه</span><FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <Map location={{ lat: location.lat, lng: location.lng, zoom: location.zoom }} />
            </Modal.Body>
        </Modal>
    );
};

export default ModalMap;
